import { NumberField } from '@base-ui/react/number-field';
import { TextField } from '@mui/material';
import React from 'react';

import { InputRenderer } from '../types';

const DIGITS_FORMAT = {
  useGrouping: false,
};

interface InputProps extends InputRenderer {
  multiline?: boolean;
}

const NumberInput = ({ fieldState, inputProps }: InputProps) => (
  <>
    <NumberField.Root
      id={inputProps.name}
      {...inputProps}
      format={DIGITS_FORMAT}
      value={inputProps.value ?? null}
      onValueChange={(value) => {
        inputProps.onChange?.({ target: { name: inputProps.name, value } } as any);
      }}
    >
      <NumberField.Input
        render={(props) => <TextField {...props} fullWidth color={undefined} error={fieldState?.invalid} />}
      />
    </NumberField.Root>
  </>
);

export default NumberInput;
